import { Instance, types } from 'mobx-state-tree';

export const NumberFromInput = types.model({
    isValid: types.boolean,
    value: types.maybeNull(types.number)
}).actions((self) => {

    const setInvalid = (): void => {
        self.isValid = false;
        self.value = null;
    }

    const setValue = (value: number): void => {
        self.isValid = true;
        self.value = value;
    }

    const setValidityAndValue = (isValid: boolean, value?: number): void => {
        self.isValid = isValid;
        self.value = value;
    }

    return {
        setInvalid,
        setValue,
        setValidityAndValue
    }
});

export type INumberFromInput = Instance<typeof NumberFromInput>;